import React from 'react';
import SummaryStyle from './MealsSummary.module.css';

function MealsSummary() {
  return (
    <article className={SummaryStyle.article}>
        <h2>Delicious Food, Delivered To You</h2>
        <p>
            Choose your favorite meal from our broad selection of available meals and enjoy a delicious lunch or dinner at home
        </p>
        <p>
            All our meals are cooked with high-quality ingrediants, just-in-time and of course by expiriance chefs!
        </p>
    </article>
  )
}

export default MealsSummary;